import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

export const SubscriptionLimitModal = ({ isOpen,
    onClose,
    message,
    feature,
    limit,
    customAction
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const getFeatureMessage = () => {
    switch (feature){
        case 'employees':
            return `Free plan is limited to ${limit} employees per roster.`;
        case 'rosters':
            return `Free plan is limited to ${limit} rosters`;
        case 'export':
            return `Free plan is limited to PDF exports only`;
        default:
            return message;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex flex-col items-center text-center">
          <AlertTriangle className="h-12 w-12 text-yellow-500 mb-4" />
          <h3 className="text-lg font-semibold mb-2">Free Plan Limitation</h3>
          <p className="text-gray-600 mb-6">{getFeatureMessage()}</p>
          
          <div className="flex gap-3 w-full">
            <button
              onClick={() => navigate('/subscription')}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Upgrade Now
            </button>
            {customAction ? (
                <button
                    onClick={customAction}
                    className='flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200'
                >
                    Try Different Format
                </button>
            ) : (
                <button
                onClick={onClose}
                className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                >
                Cancel
                </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};